<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <div dense v-bind="attrs" v-on="on" class="ml-1 mr-3">
          <v-col cols="12" class="pa-0 d-flex align-center" v-if="!oneLine">
            <v-icon small class="mr-1" color="details">mdi-clock-outline</v-icon>
            {{ event.created_at | timeShort }}
          </v-col>
          <v-col col="12" class="pa-0 d-flex align-center" v-if="!oneLine">
            <v-icon small class="mr-1" color="details">mdi-calendar-month</v-icon>
            {{ event.created_at | dateMedium }}
          </v-col>
          <v-col col="12" class="pa-0 d-flex align-center" v-if="oneLine">
            <v-icon small class="mr-1" color="details">mdi-calendar-month</v-icon>
            {{ event.created_at | dateMediumTimeShort }}
          </v-col>
        </div>
        <!-- <div v-bind="attrs" v-on="on" class="details--text ml-1 mr-3">
          <v-icon small class="mr-1" color="details">mdi-update</v-icon>
          {{ event.task_modified_at | formatDistanceWithPrefix }}
        </div> -->
      </template>
      <div style="display: grid; grid-template-columns: auto 1fr; gap: 2px 8px; align-items: center;">
        <div class="font-weight-bold">Data rozpoczęcia</div>
        <div>
          {{ event.created_at | dateMediumTimeShort }}
          <span class="ml-1 grey--text text--lighten-2">({{ date | formatDistanceWithPrefix }})</span>
        </div>
        <div class="font-weight-bold">Ostatnia modyfikacja</div>
        <div>
          {{ event.task_modified_at | dateMediumTimeShort }}
          <span class="ml-1 grey--text text--lighten-2">({{ event.task_modified_at | formatDistanceWithPrefix }})</span>
        </div>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "EventTime",

  filters: {},
  computed: {
    date: function () {
      return this.event.created_at
    }
  },
  data: () => ({}),
  props: {
    event: null,
    oneLine: {
      type: Boolean,
      default: false
    },
    classEx: String
  },
  methods: {}
}
</script>